// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.login-user {
    order: 1;
}

div.login-user > span.icon {
    margin-right: 0.25em;
}`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/Authentication.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;AACZ;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["div.login-user {\n    order: 1;\n}\n\ndiv.login-user > span.icon {\n    margin-right: 0.25em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
